import * as React from 'react';

import { AutoAuthoResult } from './auto-autho.component';

export interface AutoAuthoAuthorizationConfirmedProps {
  readonly isTripStatusUpdateEnabled: boolean;
  readonly swoId: number;
  readonly vendorEmailAddress: string;
  readonly tripStatusDescription: string;
  readonly result: AutoAuthoResult;
  readonly gotoUpdateStatusPage: () => void;
  readonly gotoValidationPage: () => void;
}

export function AutoAuthoAuthorizationConfirmed(props: AutoAuthoAuthorizationConfirmedProps): JSX.Element {
  return (
    <div className="row center-xs">
      <div className="col">
        <h2>Autho Confirmation</h2>
        <h4>SWO #: {props.swoId}</h4>
        <h4>SWO Trip Status: {props.tripStatusDescription}</h4>
        <br />
        <p>
          Your request to authorize SWO #{props.swoId} has been approved in the amount of $
          {props.result.authorizationAmount}! You may now proceed.
        </p>
        <br />
        <p>Your autho number for this request is {props.result.authorizationCode}.</p>
        <br />
        <p>For your records, an email has been sent to {props.vendorEmailAddress} with the above details.</p>
        <br />
        <button
          className="btn btn-primary"
          disabled={!props.isTripStatusUpdateEnabled}
          onClick={props.gotoUpdateStatusPage}
        >
          Update SWO Status
        </button>
        <button className="btn btn-secondary" onClick={props.gotoValidationPage}>
          Home
        </button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/auto-autho/_components/authorization-confirmed.component.tsx